<template>
    <div class="cc-delivery-address">
        <div class="cc-delivery-address__header">
            <div class="cc-delivery-address__title">{{ pickupInStore ? translations['Contact details'] : translations['Delivery address'] }}</div>
        </div>
        <div class="cc-delivery-address__main">
            <div class="cc-form-input">
                <label for="deliveryAddress.firstname" class="cc-label cc-label--text">{{ translations['Firstname'] }}*</label>
                <input id="deliveryAddress.firstname" type="text" name="deliveryAddress.firstname" class="cc-input cc-input--text" v-bind:class="{'cc-invalid': user.errors.deliveryAddress.firstname}" size="30" :value="user.deliveryAddress.firstname" @change="updateFirstname">
                <div class="cc-alert cc-alert--error" v-if="user.errors.deliveryAddress.firstname">{{ user.errors.deliveryAddress.firstname }}</div>
            </div>
            <div class="cc-form-input">
                <label for="deliveryAddress.lastname" class="cc-label cc-label--text">{{ translations['Lastname'] }}*</label>
                <input id="deliveryAddress.lastname" type="text" name="deliveryAddress.lastname" class="cc-input cc-input--text" v-bind:class="{'cc-invalid': user.errors.deliveryAddress.lastname}" size="30" :value="user.deliveryAddress.lastname" @change="updateLastname">
                <div class="cc-alert cc-alert--error" v-if="user.errors.deliveryAddress.lastname">{{ user.errors.deliveryAddress.lastname }}</div>
            </div>
            <div class="cc-form-input">
                <label for="deliveryAddress.addressLine1" class="cc-label cc-label--text">{{ translations['Address'] }}*</label>
                <input id="deliveryAddress.addressLine1" type="text" name="deliveryAddress.addressLine1" class="cc-input cc-input--text" v-bind:class="{'cc-invalid': user.errors.deliveryAddress.addressLine1}" size="30" :value="user.deliveryAddress.addressLine1" @change="updateAddressLine1">
                <div class="cc-alert cc-alert--error" v-if="user.errors.deliveryAddress.addressLine1">{{ user.errors.deliveryAddress.addressLine1 }}</div>
            </div>
            <div class="cc-form-input">
                <label for="deliveryAddress.city" class="cc-label cc-label--text">{{ translations['City'] }}*</label>
                <input id="deliveryAddress.city" type="text" name="deliveryAddress.city" class="cc-input cc-input--text" v-bind:class="{'cc-invalid': user.errors.deliveryAddress.city}" size="30" :value="user.deliveryAddress.city" @change="updateCity">
                <div class="cc-alert cc-alert--error" v-if="user.errors.deliveryAddress.city">{{ user.errors.deliveryAddress.city }}</div>
            </div>
            <div class="cc-form-input">
                <label for="deliveryAddress.country" class="cc-label cc-label--text">{{ translations['Country'] }}*</label>
                <select id="deliveryAddress.country" name="deliveryAddress.country" class="cc-input cc-input--select" v-bind:class="{'cc-invalid': user.errors.deliveryAddress.country}" :value="user.deliveryAddress.country" @change="updateCountry">
                    <option value="" disabled="disabled">{{ translations['Select country'] }}</option>
                    <option v-for="country in countries" v-bind:key="country.id" :value="country.id">{{ country.name }}</option>
                </select>
                <div class="cc-alert cc-alert--error" v-if="user.errors.deliveryAddress.country">{{ user.errors.deliveryAddress.country }}</div>
            </div>
            <div class="cc-form-input">
                <label for="deliveryAddress.postalCode" class="cc-label cc-label--text">{{ translations['Postal code'] }}*</label>
                <input id="deliveryAddress.postalCode" type="text" name="deliveryAddress.postalCode" class="cc-input cc-input--text" v-bind:class="{'cc-invalid': user.errors.deliveryAddress.postalCode}" size="10" :value="user.deliveryAddress.postalCode" @change="updatePostalCode">
                <div class="cc-alert cc-alert--error" v-if="user.errors.deliveryAddress.postalCode">{{ user.errors.deliveryAddress.postalCode }}</div>
            </div>
            <div class="cc-form-input">
                <label for="deliveryAddress.email" class="cc-label cc-label--text">{{ translations['Email'] }}*</label>
                <input id="deliveryAddress.email" type="email" name="deliveryAddress.email" class="cc-input cc-input--text" v-bind:class="{'cc-invalid': user.errors.deliveryAddress.email}" size="30" :disabled="isUserLoggedIn" :value="user.deliveryAddress.email" @change="updateEmail">
                <div class="cc-alert cc-alert--error" v-if="user.errors.deliveryAddress.email">{{ user.errors.deliveryAddress.email }}</div>
            </div>
            <div class="cc-form-input">
                <label for="deliveryAddress.phone" class="cc-label cc-label--text">{{ translations['Phone'] }}*</label>
                <input id="deliveryAddress.phone" type="text" name="deliveryAddress.phone" class="cc-input cc-input--text" v-bind:class="{'cc-invalid': user.errors.deliveryAddress.phone}" size="30" :value="user.deliveryAddress.phone" @change="updatePhone">
                <div class="cc-alert cc-alert--error" v-if="user.errors.deliveryAddress.phone">{{ user.errors.deliveryAddress.phone }}</div>
            </div>
            <div class="cc-form-input">
                <label for="deliveryAddress.additionalInformation" class="cc-label cc-label--text">{{ translations['Additional information'] }}</label>
                <textarea id="deliveryAddress.additionalInformation" type="text" name="deliveryAddress.additionalInformation" class="cc-input cc-input--text" v-bind:class="{'cc-invalid': user.errors.deliveryAddress.additionalInformation}" cols="40" rows="5" @change="updateAdditionalInformation">{{ user.deliveryAddress.additionalInformation }}</textarea>
                <div class="cc-alert cc-alert--error" v-if="user.errors.deliveryAddress.additionalInformation">{{ user.errors.deliveryAddress.additionalInformation }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        computed: {
            ...mapState({
                translations: state => state.translations,
                currentCarrier: state => state.currentCarrier,
                user: state => state.user,
                isUserLoggedIn: state => state.isLoggedIn,
                countries: state => state.config.countries,
            }),
            pickupInStore: function() {
                return this.currentCarrier ? this.currentCarrier.pickupInStore : false;
            },
        },
        methods: {
            updateEmail: function (event) {
                this.$store.dispatch('UPDATE_EMAIL', event.target.value);
            },
            updateFirstname: function (event) {
                this.$store.dispatch('UPDATE_FIRSTNAME', event.target.value);
            },
            updateLastname: function (event) {
                this.$store.dispatch('UPDATE_LASTNAME', event.target.value);
            },
            updatePhone: function (event) {
                this.$store.dispatch('UPDATE_PHONE', event.target.value);
            },
            updateAddressLine1: function (event) {
                this.$store.dispatch('UPDATE_ADDRESS_LINE_1', event.target.value);
            },
            updateCountry: function (event) {
                this.$store.dispatch('UPDATE_COUNTRY', event.target.value);
            },
            updatePostalCode: function (event) {
                this.$store.dispatch('UPDATE_POSTAL_CODE', event.target.value);
            },
            updateCity: function (event) {
                this.$store.dispatch('UPDATE_CITY', event.target.value);
            },
            updateAdditionalInformation: function (event) {
                this.$store.dispatch('UPDATE_ADDITIONAL_INFORMATION', event.target.value);
            },
        },
        name: 'DeliveryAddress',
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/components/delivery-address";
</style>
